import apiClient from '@/services/apiClient';
import mapper from '@/services/order/mapper';

export default {
	namespaced: true,
	state: {
		orders: null,
		orderCount: 0,
	},
	getters: {
		orders(state) {
			return state.orders;
		},
		orderCount(state) {
			return state.orderCount;
		},
	},
	mutations: {
		SET_ORDER_HISTORY(state, orders) {
			state.orders = mapper.mapOrders(orders);
		},
		SET_ORDER_HISTORY_COUNT(state, count) {
			state.orderCount = count;
		},
		CLEAR_STORE(state) {
			state.orders = null;
		}
	},
	actions: {
		async getOrderHistory({commit, state}, getRequirements) {
			const params = {
				...getRequirements,
				filter: ['history']
			};

			await apiClient.get('orders/get', {params}).then(res => {
				commit('SET_ORDER_HISTORY', res.data.orders);
				commit('SET_ORDER_HISTORY_COUNT', res.data.ordersCount);
			}).catch(err => {
			})
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
